import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { TournamentsService } from '../tournaments/services/tournaments.service';
declare let $;
declare let SetLanguage: any;

@Component({
    selector: 'comp_message_modal',
    templateUrl: './message_modal.html',
})
export class MessageModal implements OnInit {
    constructor(public tournamentsService: TournamentsService) {}

    init: boolean;
    ngOnInit() {
        if (this.init) return;
        this.init = true;
    }
    Message_Modal_Close() {
        $('#Message_Modal').modal('hide');
    }
}
